import { Star, BadgeCheck } from "lucide-react";

export const Stars = ({ value = 0, size = 14, testid }) => (
  <span className="inline-flex gap-0.5" data-testid={testid} aria-label={`${value} van 5 sterren`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={size} className={i <= Math.round(value) ? "fill-[#B78B7B] text-[#B78B7B]" : "text-[#D8CFC6]"} />)}
  </span>
);

export const RatingBadge = ({ rating }) => rating?.count ? (
  <a href="#reviews" className="inline-flex items-center gap-2 text-sm text-[#4A5056] hover:text-[#B78B7B]" data-testid="product-rating-summary">
    <Stars value={rating.avg} /> <span>{String(rating.avg).replace(".", ",")} · {rating.count} {rating.count === 1 ? "review" : "reviews"}</span>
  </a>
) : null;

export default function Reviews({ p }) {
  const { rating, reviews } = p;
  return (
    <section id="reviews" className="mt-16 scroll-mt-28" data-testid="product-reviews-section">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
        <div><p className="eyebrow">Ervaringen van kopers</p><h2 className="font-serif-brand text-3xl mt-2">Wat klanten zeggen</h2></div>
        {rating?.count > 0 && <div className="flex items-center gap-3 bg-white rounded-2xl px-5 py-3"><span className="font-serif-brand text-3xl">{String(rating.avg).replace(".", ",")}</span><div><Stars value={rating.avg} size={16} /><p className="text-xs text-[#6E747B]">{rating.count} geverifieerde {rating.count === 1 ? "review" : "reviews"}</p></div></div>}
      </div>
      <p data-testid="reviews-verification-policy" className="text-sm text-[#595F66] mb-5">Alleen geverifieerde kopers kunnen een review schrijven. We koppelen iedere review aan een betaalde bestelling en tonen deze na controle.</p>
      {reviews.length === 0 ? (
        <div className="bg-white rounded-3xl p-8 text-sm text-[#5A5550]" data-testid="reviews-empty">Nog geen reviews voor deze vloer. Kopers ontvangen na levering een uitnodiging om hun ervaring te delen; alleen echte kopers kunnen een review schrijven.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {reviews.map((r) => (
            <article key={r.id} className="bg-white rounded-3xl p-6" data-testid={`review-${r.id}`}>
              <div className="flex items-center justify-between gap-3"><Stars value={r.rating} /><span className="text-xs text-[#9AA0A6]">{new Date(r.created_at).toLocaleDateString("nl-NL", { month: "long", year: "numeric" })}</span></div>
              {r.title && <p className="font-medium mt-3">{r.title}</p>}
              <p className="text-sm text-[#4A5056] mt-2 leading-relaxed whitespace-pre-line">{r.text}</p>
              <p className="text-xs text-[#6E747B] mt-4 flex items-center gap-1.5">{r.name}{r.city ? ` uit ${r.city}` : ""} · <BadgeCheck size={13} className="text-[#2E7D32]" /> Geverifieerde koper</p>
              {r.reply && <div className="mt-4 bg-[#F2E6E0] rounded-2xl px-4 py-3 text-sm"><p className="text-xs font-semibold text-[#B78B7B] mb-1">Reactie van VLOVER</p>{r.reply}</div>}
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
